// ProgressContext.js
import React, { createContext, useState } from "react";

export const ProgressContext = createContext();

export const ProgressProvider = ({ children }) => {
  const [loadingProgress, setLoadingProgress] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");

  const startLoading = () => {
    setLoadingProgress(true);
    setProgress(0);
    setMessage("");
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 90) {
          clearInterval(interval);
        }
        return prevProgress + 1;
      });
    }, 80);

    return interval;
  };

  const stopLoading = (finalProgress = 99) => {
    setProgress(finalProgress);
    if (finalProgress === 99) {
      setMessage("Account Updates Completed");
      setTimeout(() => {
        setLoadingProgress(false);
        setProgress(0);
        setMessage("");
      }, 2000);
    } else {
      setLoadingProgress(false);
      setProgress(0);
      setMessage("");
    }
  };

  const stopLoadingCross = (finalProgress = progress) => {
    setProgress(finalProgress);
    setTimeout(() => {
      setLoadingProgress(false);
      setProgress(0);
    }, 100);
  };

  return (
    <ProgressContext.Provider
      value={{
        loadingProgress,
        progress,
        startLoading,
        stopLoading,
        stopLoadingCross,
        message,
      }}>
      {children}
    </ProgressContext.Provider>
  );
};
